/**
 * HelloWorld Client Mod 定义
 *
 * 演示前端业务 Mod 如何通过 ui-registry-mod 注册：
 * - 页面路由（/helloworld）
 * - 全局状态（greeting atom）
 * - 组件（HelloWorld 组件）
 * - Hook（useGreeting）
 */
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG, GLOBAL_STATE_REGISTRY_INTERFACE_TAG, COMPONENT_REGISTRY_INTERFACE_TAG, HOOKS_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { HelloworldRegistrar } from './helloworld-registrar.js';
/**
 * helloworld-client-mod
 *
 * 演示前端注册模式：页面、状态、组件、Hook 的统一注册。
 */
export const helloworldClientMod = {
    name: 'helloworld-client',
    modDependencies: ['ui-registry'],
    serviceDefs: [
        {
            serviceTag: 'helloworldRegistrar',
            serviceImpl: HelloworldRegistrar,
            dependencies: [
                PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
                GLOBAL_STATE_REGISTRY_INTERFACE_TAG,
                COMPONENT_REGISTRY_INTERFACE_TAG,
                HOOKS_REGISTRY_INTERFACE_TAG,
            ],
        },
    ],
};
//# sourceMappingURL=mod.js.map